module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "Mybalance"
  }, [_vm._v("我的学费")]), _vm._v(" "), _c('div', {
    staticClass: "zhScholarship"
  }, [_c('div', {
    staticClass: "zhLeft"
  }, [_c('p', {
    staticClass: "remainderChild"
  }, [_vm._v("我的学费"), _c('i', [_vm._v("￥")]), _c('span', [_vm._v(_vm._s(_vm.tuition.tuition))]), _c('b', {
    staticClass: "integral"
  }, [_vm._v("(含积分" + _vm._s(_vm.tuition.integral_pe) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "zhRight"
  }, [_c('div', {
    staticClass: "zhSign"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-outline"
    }
  })], 1), _c('i', {
    staticClass: "zhJiang1",
    on: {
      "click": _vm.Tuition1
    }
  }, [_vm._v("学费规则")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Tuition),
      expression: "Tuition"
    }],
    staticClass: "zhInformation1"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._l((_vm.tuiList), function(tui) {
    return _c('div', {
      staticClass: "dateList"
    }, [_c('div', {
      staticClass: "datesList"
    }, [_vm._v(_vm._s(tui.date))]), _vm._v(" "), _c('div', {
      staticClass: "incomeList"
    }, [_vm._v(_vm._s(tui.price) + "(包含积分" + _vm._s(tui.integral) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "detailInfoList"
    }, [_vm._v(_vm._s(tui.remark)), (tui.order_id) ? _c('span', [_vm._v("，订单号：" + _vm._s(tui.order_id))]) : _vm._e(), (tui.timeout) ? _c('span', [_vm._v("，有效期：" + _vm._s(tui.timeout))]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "zhhContent"
  }, [_c('Page', {
    attrs: {
      "total": _vm.zhPage.total,
      "page-size": 20
    },
    on: {
      "on-change": _vm.handlePages
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zhTotal"
  }, [_vm._v("\n              共" + _vm._s(_vm.zhPage.total) + "条记录\n            ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("Q")]), _vm._v("学费的来源有哪些？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem1"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("A")]), _vm._v("学费的来源有两个：第一是购买诺亚财富特定产品会赠送学费；第二是诺亚财富会员的积分会按照4:1的比例折算成学费。（赠送和积分转化的具体规则及解释权由诺亚财富集团发布）")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("Q")]), _vm._v("学费可以用来做什么？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem1"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("A")]), _vm._v("可以在报名课程时抵扣课程报名费，其中抵扣顺序是先抵扣特定产品赠送学费，再抵扣积分。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("Q")]), _vm._v("学费有有效期吗？")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhProblem1"
  }, [_c('span', {
    staticClass: "zhP"
  }, [_vm._v("A")]), _vm._v("特定产品赠送学费有效期两年，超出期限未使用的将被清零不可再使用。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wholeBalance"
  }, [_c('div', {
    staticClass: "wholeword"
  }, [_vm._v("全部")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detailList"
  }, [_c('div', {
    staticClass: "dates"
  }, [_vm._v("日期")]), _vm._v(" "), _c('div', {
    staticClass: "income"
  }, [_vm._v("收入/支出")]), _vm._v(" "), _c('div', {
    staticClass: "detailInfo"
  }, [_vm._v("详细信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a33985ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderList/MyBalance.vue
// module id = 563
// module chunks = 1